<template>
  <v-container class="featuredArticles-container py-lg-16 py-10 px-3 px-sm-6 px-lg-3" v-if="news.length > 0">
    <v-row class="pb-lg-16 pb-5">
      <v-col>
        <h3
          class="text-lg-h3 text-h5 text-navy font-weight-bold px-5 px-lg-0"
          v-html="$t('news.featuredArticles')"
        ></h3>
      </v-col>
    </v-row>
    <slick ref="slick" :options="slickOptions" class="text-center px-lg-10 ">
      <div
        class="d-flex flex-column align-center"
        v-for="(newItem, index) in news"
        :key="index"
      >
        <v-card
          class="mx-auto background-green-light elevation-0 rounded-lg"
          max-width="310"
         
        >
          <v-img :src="newItem.upload.path" height="170"></v-img>

          <v-card-title class="text-white ">
          <h6 class="line-limit-2 pa-0 ma-0 text-lg-h6 font-weight-bold text-left">
            {{ newItem.title }}
          </h6>
          </v-card-title>
        </v-card>
        <v-btn
          class="
            elevation-0
            mt-lg-10
            mt-5
            btn-first
            text-capitalize text-lg-h6
            font-weight-bold
          "
          outlined
          width="200"
          :to="'/news/'+ newItem.slug"
        >
          {{ $t("home.keepReading") }}</v-btn
        >
      </div>
    </slick>
  </v-container>
</template>
<script>
import NewService from "@/services/new";

export default {
  props: {
    department: {
      type: String,
    },
  },
  name: "featuredArticles",
  data() {
    return {
      news: [],
      slickOptions: {
        arrows: true,
        autoplay: false,
        slidesToShow: 3,
        infinite: false,
        prevArrow:
          "<img class='a-left control-c prev slick-prev' src='/left.svg'>",
        nextArrow:
          "<img class='a-right control-c next slick-next' src='/right.svg'>",

        cssEase: "linear",

        responsive: [
          {
            breakpoint: 1265,
            settings: {
              centerMode: true,
              slidesToShow: 2,
            },
          },
          {
            breakpoint: 1264,
            settings: {
              centerMode: false,
              slidesToShow: 2,
            },
          },
          {
            breakpoint: 600,
            settings: {
              centerMode: false,
              slidesToShow: 1,
            },
          },
        ],
      
      },
      
    };
  },
  async created() {
    this.news = await NewService.getNews();
    this.news = this.news.filter( (newItem) => newItem.featured );
  },
 
};
</script>
